// Host names as people paste them, and the service hosts that follow from the shop's.
import { parseHosts } from './htaccess';

/** A pasted URL becomes its host name: no scheme, path, query, port or trailing dot; lower case. */
export function toHost(value: string): string {
  return value
    .trim()
    .toLowerCase()
    .replace(/^[a-z][a-z0-9+.-]*:\/\//, '')
    .replace(/[/?#].*$/, '')
    .replace(/:\d+$/, '')
    .replace(/\.$/, '');
}

/** Host names from a comma, space or line separated text, URLs allowed. */
export function parseHostList(text: string): string[] {
  return parseHosts(text).map(toHost).filter(Boolean);
}

/**
 * The service host that goes with a shop host: `shop-schger.stage.x` → `cashdesk-schger.stage.x`, `shop.x` → `cashdesk.x`,
 * anything else gets the prefix on its first label (`web.x` → `cashdesk-web.x`).
 */
export function serviceHost(shopHost: string, prefix: string): string {
  const [first = '', ...rest] = shopHost.split('.');
  const label = first === 'shop' ? prefix : first.startsWith('shop-') ? prefix + first.slice('shop'.length) : `${prefix}-${first}`;
  return [label, ...rest].join('.');
}

/** One service host per shop host, comma-separated, as the service host field shows it. */
export function suggestServiceHosts(shopHosts: string, prefix: string): string {
  return parseHostList(shopHosts)
    .map((h) => serviceHost(h, prefix))
    .join(', ');
}

/** The domain environments get on this cluster, from the UI's own host: `peak.stage.peaksolution.com` → `stage.peaksolution.com`. */
export function clusterDomain(uiHost: string): string | undefined {
  return /^peak\.([a-z0-9-]+\.[a-z0-9.-]+)$/.exec(uiHost.toLowerCase())?.[1];
}

/** The shop host a new environment gets unless one is typed: `shop-<name>.<cluster domain>`. */
export function defaultShopHost(name: string, domain: string | undefined): string {
  const n = name.trim().toLowerCase();
  return n && domain ? `shop-${n}.${domain}` : '';
}
